module.exports = __webpack_public_path__ + "img/food-placeholder.ecd9fc48.svg";